import VueTypes from 'vue-types';

export const anchorLinkProps = {
  href: VueTypes.string.isRequired,
  isTargetBlank: VueTypes.bool.def(false),
};

export const titledLinkProps = {
  ...anchorLinkProps,
  title: VueTypes.string.def(''),
};
